import {
  sortByPosition,
  sortByPositionAndUpdateIndex
} from "shared/lib/sorting/sortByPosition"
import {
  ProjectChild,
  isProjectFloor,
  isProjectRoom
} from "shared/types/Project"

export function sortProjectChildren(children: null | undefined): null
export function sortProjectChildren(children: ProjectChild[]): ProjectChild[]
export function sortProjectChildren(
  children: ProjectChild[] | null | undefined
): ProjectChild[] | null
export function sortProjectChildren(
  children: ProjectChild[] | null | undefined
): ProjectChild[] | null {
  if (!children) {
    return null
  }
  return sortByPosition(children)?.map(child => {
    if (isProjectFloor(child)) {
      return {
        ...child,
        children: sortByPosition(child.children)
      }
    }
    if (isProjectRoom(child)) {
      return {
        ...child,
        children: sortByPosition(child.children)
      }
    }

    return child
  })
}

export function sortProjectChildrenAndUpdateIndex(
  children: null | undefined
): null
export function sortProjectChildrenAndUpdateIndex(
  children: ProjectChild[]
): ProjectChild[]
export function sortProjectChildrenAndUpdateIndex(
  children: ProjectChild[] | null | undefined
): ProjectChild[] | null
export function sortProjectChildrenAndUpdateIndex(
  children: ProjectChild[] | null | undefined
): ProjectChild[] | null {
  if (!children) {
    return null
  }
  return sortByPositionAndUpdateIndex(children)?.map(child => {
    if (isProjectFloor(child)) {
      return {
        ...child,
        children: sortByPositionAndUpdateIndex(child.children)
      }
    }
    if (isProjectRoom(child)) {
      return {
        ...child,
        children: sortByPositionAndUpdateIndex(child.children)
      }
    }

    return child
  })
}
